
const Footer = () => {
  return (
    <footer className="footer">
      <p>&copy; 2024 My Company. All rights reserved.</p>
    </footer>
  );
};

export default Footer;
